import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      value: _ctx.value,
      "allow-clear": "",
      "show-search": "",
      multiple: false,
      placeholder: _ctx.placeholder,
      "option-filter-prop": "title",
      onChange: _ctx.onChange,
      onClear: _ctx.onClear,
      disabled: _ctx.isEdit,
      virtual: false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.records, (item) => {
          return (_openBlock(), _createBlock(_component_a_select_option, {
            key: `${item.id}`,
            value: `${item.id}`,
            title: item.name
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["value", "title"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "placeholder", "onChange", "onClear", "disabled"])
  ]))
}